<template>
  <div v-if="bodyShow">
    <img class="ban" src="@a/pblic_welfare/welfare_ban.png" width="100%" alt />
    <div class="welfare-main">
      <!-- <h2 class="title">
        <span>新精英“生涯职场课程助力大学生”<br/></span>
        新精英“生涯职场课程助力大学生”系列免费课程，是新精英生涯提供给全国大学生的公益课程，在这个特殊时期新精英希望为高校，辅导员，大学生提供一些专业上的支持和力所能及的服务。这次开放的课程，精选自新精英线上课程平台“橙子学院”，服务即将踏上职场的毕业生和在为职场提前做准备的在校大学生，精品课程，落地实用。在这个特殊时期，新精英愿意陪伴你们一起为未来做准备。<br/><br/>
        听课过程中遇到问题，请联系：朱老师  18519370485（微信/电话）
      </h2>-->
      <!-- 七天训练营 -->
      <div class="welfare-child">
        <img src="@a/top.png" />
        <div class="content">
          <!-- <h3 class="text-ellipsis-2">《7天突破职业发展瓶颈特训营》—高校</h3>
          <h5 class="text-ellipsis-3">帮你搞清楚什么工作适合你，晰职业定位，明确发展路径！</h5>-->
          <!-- 按钮 -->
          <div class="footer-btn">
            <span>售价￥199 元</span>
            <a @click="toSuccessLink('7day')">进入课程</a>
            <!-- <a v-if="day7Bool" @click="toSuccessLink('7day')">进入课程</a>
            <a v-else @click="toLink('7day')">领取课程</a>-->
          </div>
        </div>
      </div>
      <!-- 循环 -->
      <div class="welfare-child" v-for="(item,index) in list" :key="index">
        <img :src="item.background_image" />
        <div class="content">
          <h3 class="text-ellipsis-2">{{item.title}}</h3>
          <h5 class="text-ellipsis-3">{{item.desc}}</h5>
          <!-- 按钮 -->
          <div class="footer-btn">
            <span>售价￥{{item.price}} 元</span>
            <a v-if="item.bool" @click="toSuccessLink(item.id)">进入课程</a>
            <a v-else @click="toLink(item.id)">领取课程</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { exchange } from "@/api/other";
import { shareCon } from "@/utils/wxconfig";
import { getStorage, setStorage, deepCopy } from "@/utils/tools";
export default {
  data() {
    return {
      bodyShow: false,
      day7Bool: false,
      list: []
    };
  },
  methods: {
    // 跳转成功页面
    toSuccessLink(id) {
      if (id == "7day") {
        window.location.href = `https://appty2gguua5789.h5.xiaoeknow.com/v1/course/column/p_5e7063254efcd_GTXcrcCW?type=3&share_user_id=u_5bbef4a735603_o34b1BBgSm&share_type=2&scene=%E5%88%86%E4%BA%AB&entry=2&entry_type=2001&is_redirect=1`;
      } else {
        window.location.href = `https://api.xjy.cn/chengzi/task/detail.html?id=${id}&action=learn`;
      }
    },
    // 领取课程
    toLink(id) {
      window.location.href = `https://api.xjy.cn/chengzi/my/exchange_384?redirect_url=${encodeURIComponent(
        window.location.href
      )}&success=1`;
      if (id == "7day") {
        setStorage(this.$route.path, id, 1);
      } else {
        setStorage(this.$route.path, "success" + id, 1);
      }
    },
    // 初始化方法
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      exchange().then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return false;
        }
        document.title = "新精英“生涯职场课程助力大学生”";
        this.list = data.list;

        for (let i = 0; i < this.list.length; i++) {
          if (getStorage(this.$route.path, `success${this.list[i].id}`) == 1) {
            this.list[i].bool = true;
          } else {
            this.list[i].bool = false;
          }

          if (getStorage(this.$route.path, `7day`)) {
            this.day7Bool = true;
          }
        }
        this.bodyShow = true;

        //关闭加载中
        this.$emit("loadingHandle", false);
      });
    }
  },
  created() {
    this.pullData();
    shareCon("index", this);
  }
};
</script>

<style lang="scss" scoped>
.ban{
    border: none;
}
.welfare-main {
  padding: 0px 30px 30px;
  background-color: #fff;
  h2.title {
    -webkit-user-select: text !important;
    -khtml-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    user-select: text !important;
    font-size: 32px;
    margin-bottom: 20px;
    line-height: 48px;
    color: #333;
    span {
      font-weight: bold;
      font-size: 38px;
    }
  }
  .welfare-child {
    width: 100%;
    min-height: 100px;
    margin-bottom: 30px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    &:last-child() {
      margin-bottom: 0;
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      height: 100%;
      text-align: left;
      letter-spacing: 1px;
      padding: 30px;
      display: flex;
      flex-direction: column;
      h3 {
        font-size: 32px;
        margin-bottom: 20px;
        width: 340px;
      }
      h5 {
        width: 340px;
        line-height: 38px;
      }
      .footer-btn {
        margin-top: auto;
        display: flex;
        width: 320px;
        align-items: center;
        a {
          display: block;
          margin-left: auto;
          border: 2px solid #fff;
          padding: 0 20px;
          line-height: 50px;
          border-radius: 25px;
          font-size: 24px;
        }
      }
    }
    img {
      width: 100%;
    }
  }
}
</style>